import { useCallback } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

/**
 * Hook that provides handlers for managing max leverage flag state.
 *
 * This hook provides two distinct handlers:
 * - handleMaxLeverageClick: Sets maxLeverageSelected to true (for 100% button clicks)
 * - handleFormChange: Sets maxLeverageSelected to false (for all other form changes)
 *
 * This ensures maxLeverageSelected is only true when explicitly clicking the 100% button
 * in PerpLeverageSliderInput, and gets reset to false for any other form interaction.
 */
export const useMaxLeverageHandlers = () => {
	const setTradeFormMaxLeverageSelected = useVelocityStore(
		(s) => s.setTradeFormMaxLeverageSelected
	);

	/**
	 * Handler for when the 100% button is clicked in PerpLeverageSliderInput.
	 * Sets maxLeverageSelected to true.
	 */
	const handleMaxLeverageClick = useCallback(() => {
		setTradeFormMaxLeverageSelected(true);
	}, [setTradeFormMaxLeverageSelected]);

	/**
	 * Handler for all other form changes (input changes, slider moves, etc.).
	 * Sets maxLeverageSelected to false.
	 */
	const handleFormChange = useCallback(() => {
		setTradeFormMaxLeverageSelected(false);
	}, [setTradeFormMaxLeverageSelected]);

	return {
		handleMaxLeverageClick,
		handleFormChange,
	};
};
